const ON_CHANGE_DEBOUNCE_TIMER = 300;
const VIEW_TRANSITION_CLEANUP_DELAY_MS = 500;
const STICKY_HEADER_HYSTERESIS_BUFFER_PX = 30;
const CART_STATUS_TIMEOUT_MS = 1000;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
